"use client";
import { WorldMap } from "../ui/world-map";

function Contact() {
  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="mb-4">
          <h4 className="text-primary font-medium text-center">Contact</h4>
        </div>
        <h2 className="text-3xl font-bold text-center mb-8">Expand Globally</h2>
        <p className="mt-4 text-xl text-gray-600 text-center mb-8">
          Connect with customers worldwide and grow your business across borders with our international e-commerce solutions.
        </p>
      </div>
      <div className="rounded-md p-4 shadow-lg border border-gray-300 max-w-sm sm:max-w-xl md:max-w-7xl mx-auto">
        <div>
          <WorldMap
            dots={[
              {
                start: {
                  lat: 64.2008,
                  lng: -149.4937,
                }, // Alaska (Fairbanks)
                end: {
                  lat: 34.0522,
                  lng: -118.2437,
                }, // Los Angeles
              },
              {
                start: { lat: 64.2008, lng: -149.4937 }, // Alaska (Fairbanks)
                end: { lat: -15.7975, lng: -47.8919 }, // Brazil (Brasília)
              },
              {
                start: { lat: -15.7975, lng: -47.8919 }, // Brazil (Brasília)
                end: { lat: 38.7223, lng: -9.1393 }, // Lisbon
              },
              {
                start: { lat: 51.5074, lng: -0.1278 }, // London
                end: { lat: 28.6139, lng: 77.209 }, // New Delhi
              },
              {
                start: { lat: 28.6139, lng: 77.209 }, // New Delhi
                end: { lat: 43.1332, lng: 131.9113 }, // Vladivostok
              },
              {
                start: { lat: 28.6139, lng: 77.209 }, // New Delhi
                end: { lat: -1.2921, lng: 36.8219 }, // Nairobi
              },
            ]}
            lineColor="#0049ac"
            className="w-full"
          />
        </div>
      </div>
      <div className="text-center mt-8">
        <a
          href="/contact"
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full text-white bg-[#0049ac] hover:scale-105 transform transition-all duration-300 font-poppins"
        >
          Get Started Today
        </a>
      </div>
    </div>
  );
}

export default Contact;
